import haml from "refractor/haml";
export default haml;